import { useShallow } from 'zustand/react/shallow';

import { Constants } from '../../common/Constants';
import { ConstantsLagoon } from '../../common/ConstantsLagoon';
import { getFeatureFlag } from '../../common/Utils';
import { useChipStore } from '../../store/useChipStore';
import { ChipState } from '../../store/useChipStore/chipStore';
import { useLagoon } from '../useLagoon';

export const getProviderType = (providerType: string) => {
  switch (providerType?.toLowerCase()) {
    case 'practitioner':
      return 'practitioners';
    case 'medical group':
    case 'provider group':
    case 'provider groups':
    case 'medical_group':
      return 'provider_groups';
    case 'organization':
    case 'facility':
      return 'facilities';
    default:
      return providerType;
  }
};
export const createLlmFlagTransformer =
  (toggle: boolean) =>
  (x: string): string =>
    toggle ? x + '_SPECIALITY' : x;

export const getCategoryLLMFlag = (
  featureFlags: any,
  providerType: string,
  chipCategory: string,
  specialityFlagOverride = false
) => {
  // Use "MEDICAL_SPECIALISTS" if chipCategory is "facilities" otherwise use the actual chipCategory
  const categoryForFlag =
    chipCategory?.toLowerCase() === 'facilities'
      ? 'MEDICAL_SPECIALISTS'
      : chipCategory?.toUpperCase()?.split(' ').join('_');
  // specialityFlagOverride selects the base or _SPECIALITY flag; defaults to base so callers fail safe
  const applyTransform = createLlmFlagTransformer(specialityFlagOverride);

  if (providerType) {
    return getFeatureFlag(
      featureFlags,
      applyTransform(
        ConstantsLagoon.FEATURE_FLAGS.ENABLE_LLM +
          '_' +
          categoryForFlag +
          '_' +
          getProviderType(providerType)?.toUpperCase()
      )
    );
  } else {
    return getFeatureFlag(
      featureFlags,
      ConstantsLagoon.FEATURE_FLAGS.ENABLE_LLM + '_' + categoryForFlag
    );
  }
};

export const useCategoryLLMFlag = (
  providerType: string,
  chipCategory?: string
) => {
  const featureFlags = useLagoon(Constants.LAGOON_TABLE.FEATURE_FLAGS)();

  const { chipValue } = useChipStore(
    useShallow((state: ChipState) => ({
      chipValue: state.chipValue,
    }))
  );

  return getCategoryLLMFlag(
    featureFlags,
    providerType,
    chipCategory || chipValue
  );
};
